import React from "react";

const OrgTableShimmer = ({ columns = 4, rows = 6, titleWidth = "180px" }) => {
  const columnWidths = Array.from({ length: columns }, (_, index) => {
    if (columns === 1) return "70%";
    if (index === columns - 1) return "18%";
    if (index === 0) return "24%";
    return "1fr";
  });

  return (
    <div className="org-shimmer" aria-hidden="true">
      <div className="org-shimmer__header">
        <div className="org-shimmer__line org-shimmer__line--title" style={{ width: titleWidth }} />
        <div className="org-shimmer__actions">
          <div className="org-shimmer__line org-shimmer__line--input" />
          <div className="org-shimmer__line org-shimmer__line--button" />
        </div>
      </div>

      <div className="org-shimmer__table">
        <div
          className="org-shimmer__row org-shimmer__row--head"
          style={{ gridTemplateColumns: columnWidths.join(" ") }}
        >
          {Array.from({ length: columns }).map((_, index) => (
            <div key={`head-${index}`} className="org-shimmer__line org-shimmer__line--head" />
          ))}
        </div>

        {Array.from({ length: rows }).map((_, rowIndex) => (
          <div
            key={`row-${rowIndex}`}
            className="org-shimmer__row"
            style={{ gridTemplateColumns: columnWidths.join(" ") }}
          >
            {Array.from({ length: columns }).map((_, columnIndex) => (
              <div
                key={`cell-${rowIndex}-${columnIndex}`}
                className={`org-shimmer__line ${columnIndex === columns - 1 ? "org-shimmer__line--short" : ""}`}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default OrgTableShimmer;
